
export default class HideBackground {
	constructor() {
		this.init();
	}

	manageBg (container, bg) { // if the body does not have the styling class for the bg then hide the html of the bg otherwise show it
		const bgElement = document.querySelectorAll('.' + bg);

		if (!document.querySelector('.HideBackground').classList.contains(container)) {
			bgElement.forEach((element) => {
				element.classList.add('hide-bg');
			});
		}

		else { //we display the background
			bgElement.forEach((element) => {
				element.classList.remove('hide-bg');
			});

			if (bg == 'eagerlyicon-bg1' && document.querySelector('.HideBackground').classList.contains('bg1-container--case2') ) {
				bgElement.forEach((element) => {
					element.classList.add('case-2'); // we add case-2 class so the svg is flipped to match the design
				});
			}
		}
	}

	init() {

		const screen = document.documentElement.scrollHeight;
		const case2 = document.querySelectorAll('.bg1-container--case2');
		// these values will be tweaked when the content of the pages is filled

		if (screen > 3900) {
			this.manageBg('bg1-container', 'eagerlyicon-bg1');
			this.manageBg('bg2-container', 'eagerlyicon-bg2');
			this.manageBg('bg-small1-container', 'eagerlyicon-bg-small1');
		}
		// else if (screen > 2500 && screen < 3500 || screen > 1400 && screen <2000 && case2.length>0) {
		// 	this.manageBg('bg1-container', 'eagerlyicon-bg1');
		// }
		else  {
			this.manageBg('bg1-container', 'eagerlyicon-bg1');
		}

	}
}
